import React from 'react';
import { Row, Col } from 'react-bootstrap'

import Loading from '../../components/shared/Loading'
import { commifyNumber } from '../../utils/utilities'
import ConvertibleText from '../../components/shared/ConvertibleText'


class GCLimits extends React.Component {
    constructor(props) {
        super(props)

        this.onBlurHandler = this.onBlurHandler.bind(this)
    }

    onBlurHandler(priceValue) {
        const { limits = {}, type } = this.props
        const { u658 = {}, ocp008a = {} } = limits
        const key = Object.keys(priceValue)[0]
        priceValue[key] = `$${commifyNumber(priceValue[key])}`
        if (type === 'oi') {
            Object.assign(u658, priceValue)
        } else {
            Object.assign(ocp008a, priceValue)
        }
        this.props.onBlurHandler({ limits: type === 'oi' ? {u658} : {ocp008a} })
    }

    render() {
        const { isModified, limits: { u658 = {}, ocp008a = {} } = {}, manuallySetPricing, type } = this.props
        const { occurenceLimit = '', aggregateLimit = '', completedOpsLimit = '' } = u658
        const { eachOccurrence = '', generalAggregate = '' } = ocp008a

        return (
            <div className="gcLimitsContainer">
                <h4 className="quoteTitle">GC Required Limits</h4>
                <div>
                    <Row>
                        <Col xs={8} md={6}>
                            <div className="premiumGrid">
                                <span className="h5">Each Occurrence</span>
                                <span className="h4">{ 
                                    isModified 
                                    ? <Loading width="23px" height="23px" /> 
                                    : <ConvertibleText 
                                        manuallySetPricing={manuallySetPricing}  
                                        value={{
                                            name: type === 'oi' ? 'occurenceLimit' : 'eachOccurrence', 
                                            text: type === 'oi' ? occurenceLimit : eachOccurrence 
                                        }} 
                                        onBlurHandler={this.onBlurHandler}
                                    />
                                    }
                                </span>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={8} md={6}>
                            <div className="premiumGrid">
                                <span className="h5">General Aggregate</span>
                                <span className="h4">{ 
                                    isModified 
                                    ? <Loading width="23px" height="23px" /> 
                                    : <ConvertibleText 
                                        manuallySetPricing={manuallySetPricing}  
                                        value={{
                                            name: type === 'oi' ? 'aggregateLimit' : 'generalAggregate',
                                            text: type === 'oi' ? aggregateLimit : generalAggregate
                                        }} 
                                        onBlurHandler={this.onBlurHandler}
                                    />
                                    }
                                </span>
                            </div>
                        </Col>
                    </Row>
                    {(type === 'oi') && (
                        <Row>
                            <Col xs={8} md={6}>
                                <div className="premiumGrid">
                                    <span className="h5">Product Completed Ops</span>
                                    <span className="h4">{ 
                                        isModified 
                                        ? <Loading width="23px" height="23px" /> 
                                        : <ConvertibleText 
                                            manuallySetPricing={manuallySetPricing}  
                                            value={{name: 'completedOpsLimit', text: completedOpsLimit}} 
                                            onBlurHandler={this.onBlurHandler}
                                        />
                                        }
                                    </span>
                                </div>
                            </Col>
                        </Row>)}
                </div>
            </div>
        )
    }
}

export default GCLimits